<iframe id="cardinal_collection_iframe" name="collectionIframe" style="display: none;"></iframe>
<form id="cardinal_collection_form" #deviceDataCollectionForm ngNoForm name="deviceDataCollectionForm" method="POST" target="collectionIframe" [action]="deviceDataCollectionSetup?.deviceDataCollectionUrl">
    <input id="cardinal_collection_form_input" type="hidden" name="JWT" [value]="deviceDataCollectionSetup?.accessToken">
</form>
